/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAIConfigTriggersPathParams = NonNullable<operations['listAIConfigTriggers']['parameters']['path']>;

export type ListAIConfigTriggersQueryParams = NonNullable<operations['listAIConfigTriggers']['parameters']['query']>;

export interface Input extends ListAIConfigTriggersPathParams {
  apiVersion?: string;
  query?: ListAIConfigTriggersQueryParams;
  header: NonNullable<operations['listAIConfigTriggers']['parameters']['header']>;
}

export async function listAIConfigTriggers(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/{configKey}/triggers', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
